import React, { useEffect, useState } from "react";
import SplitPane from "react-split-pane";
import { Card, Table } from "react-bootstrap";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import StudyDocumentoffcanvasData from "./StudyDocumentoffcanvasData";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import Moment from "react-moment";
import { MdDelete } from "react-icons/md";
import { FaDownload } from "react-icons/fa";
import { studyDocumentServices } from "../../../Services/studyDocumentServices";
import UseToggle from "../../../Hooks/UseToggle";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../Pagination";

const StudyDocument = () => {
  const [showPdfData, setShowPdfData] = useState("");
  const [loader, setLoader] = useState(false);
  const [studyDocument, setStudyDocument] = useState([]);
  const { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));
  const { toggle, setToggle } = UseToggle();
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);

  const canDownload =  !(studyPermission?.qrReadOnly || studyPermission?.liveReadOnly ) && (StudyMode === "DBP Mode" || studyPermission?.liveDownloadDocument || studyPermission?.liveSDVDownloadDocument || studyPermission?.qcDownloadDocument || studyPermission?.qcSDVDownloadDocument);
  const canDelete =  !(studyPermission?.qrReadOnly || studyPermission?.liveReadOnly ) && (StudyMode === "DBP Mode" || studyPermission?.liveDeleteDocument || studyPermission?.liveSDVDeleteDocument || studyPermission?.qcDeleteDocument || studyPermission?.qcSDVDeleteDocument);
  const canAdd =  !(studyPermission?.qrReadOnly || studyPermission?.liveReadOnly ) && (StudyMode === "DBP Mode" || studyPermission?.liveUploadDocument || studyPermission?.liveSDVUploadDocument || studyPermission?.qcUploadDocument || studyPermission?.qcSDVUploadDocument);

  const getStudyDocument = async () => {
    setLoader(true);
    const data = await studyDocumentServices.getStudyDocument(studyId, StudyMode);
    setStudyDocument(data?.data || []);
    setLoader(false);
  };

  const deleteStudyDocumentData = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete Data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    });
    if (result.isConfirmed) {
      const res = await studyDocumentServices.deleteStudyDocument(studyId, id);
      if (res?.statusCode === 200) getStudyDocument();
    }
  };

  const startIndex = (pageNumber - 1) * itemsPerPage;
  const result = studyDocument.slice(startIndex, startIndex + itemsPerPage);
  const totalPage = Math.ceil(studyDocument.length / itemsPerPage);

  useEffect(() => {
    getStudyDocument();
  }, [studyId]);

  return (
    <>
      {canAdd && (
        <div className="justify-content-between toolbar border-bottom hstack p-1" style={{height: 36}}>
          <div className="hstack gap-1">
            <i
              onClick={setToggle}
              title="Add Study Document"
              className="fa-solid fa-square-plus CP"
            ></i>
          </div>
        </div>
      )}

      <SplitPane split="vertical" minSize={20} defaultSize="40%" className="position-relative" style={{ height: "calc(100vh - 175px)" }}>
        
        {/* Left Pane */}
        {loader ? (
          <PageLoader/>
        ) : result.length === 0 ? (
          <NoDataFoundTable MSG="Study Document not Found!" />
        ) : (
          <div className="overflow-auto" style={{ height: "calc(100vh - 180px)" }}>
            <Table striped hover className="m-0 custom-table">
              <thead className="thead-sticky top-0">
                <tr>
                  <th style={{ width: 45 }}>Sr.</th>
                  <th>Document Name</th>
                  <th style={{ width: 80 }}>File Type</th>
                  <th>Uploaded Date</th>
                  {canDownload && <th style={{ width: 80 }} className="text-center">Download</th>}
                  {canDelete && <th style={{ width: 80 }} className="text-center">Delete</th>}
                </tr>
              </thead>
              <tbody>
                {result.map((item, index) => (
                  <tr key={item._id} className={`CP ${showPdfData === item.fileURL ? "highlighted" : ""}`}>
                    <td onClick={() => setShowPdfData(item.fileURL)}>{startIndex + index + 1}</td>
                    <td onClick={() => setShowPdfData(item.fileURL)}>{item.documentName}</td>
                    <td onClick={() => setShowPdfData(item.fileURL)}>{item.fileType}</td>
                    <td onClick={() => setShowPdfData(item.fileURL)}>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>{item.createdAt}</Moment>
                    </td>
                    {canDownload && (
                      <td className="text-center">
                        <a href={item.fileURL}><FaDownload className="text-success" style={{ width: 15, height: 15 }} /></a>
                      </td>
                    )}
                    {canDelete && (
                      <td className="text-center">
                        <MdDelete className="text-danger CP" style={{ width: 15, height: 15 }} onClick={() => deleteStudyDocumentData(item._id)} />
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={studyDocument.length}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        )}

        {/* Right Pane */}
        <div className="overflow-auto" style={{ height: "calc(100vh - 180px)" }}>
          {showPdfData && (
            <Card className="shadow-sm border-0">
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                <Viewer fileUrl={showPdfData} />
              </Worker>
            </Card>
          )}
        </div>
      </SplitPane>

      <StudyDocumentoffcanvasData
        show={!toggle}
        onHide={setToggle}
        studyId={studyId}
        getStudyDocument={getStudyDocument}
      />
    </>
  );
};

export default StudyDocument;
